import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/shop/payments'

export default {
  async amendPayUrl(url, payload) {
    return await axios
      .post(process.env.VUE_APP_BASE_API + `/${url}`, payload)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async amendPayCredit(param) {
    return await axios
      .get(endpoint + `/amend/pay/credit?${param}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async generateUrl(request) {
    return await axios
      .post(endpoint + '/url', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async payWithDeposit(request) {
    return await axios
      .post(endpoint + '/deposit', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async payWithInvoice(request) {
    return await axios
      .post(endpoint + '/invoice', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async payWithCredit(request) {
    return await axios
      .get(endpoint + `/credit${request}`)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async rdpFirstPhase(request) {
    return await axios
      .post(endpoint + '/reddot/firstphase', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  },
  async payPalCaptureOrder(request) {
    return await axios
      .post(endpoint + '/paypal/capture', request)
      .then(response => {
        return response.data
      }).catch(error => {
        throw error.response.data
      });
  }
}



// WEBPACK FOOTER //
// ./src/services/shop/paymentService.js